// extracted by mini-css-extract-plugin
export default {"complete":"styles_complete__R6n8N","incomplete":"styles_incomplete__rXAeb"};